"use strict";

var DisableOnSubmitMixin;

DisableOnSubmitMixin = {
  disabled: function disabled() {
    if (this.props.disabled != null) {
      if (typeof this.props.disabled === "function") {
        return this.props.disabled();
      } else {
        return this.props.disabled;
      }
    } else {
      return this.props.submitting && true;
    }
  }
};

module.exports = DisableOnSubmitMixin;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/mixins/DisableOnSubmit.js
 ** module id = 284
 ** module chunks = 0
 **/